export default __webpack_public_path__ + "static/media/sushi.7027ec5a.png";